export default "/static/webpack/images/profile/facebook-glyph.svg";